module.exports = __webpack_public_path__ + "img/logo-white.34e6c4fa.svg";